import { render, staticRenderFns } from "./DayCloseScreen.vue?vue&type=template&id=c1545412"
import script from "./DayCloseScreen.vue?vue&type=script&lang=js"
export * from "./DayCloseScreen.vue?vue&type=script&lang=js"
import style0 from "./DayCloseScreen.vue?vue&type=style&index=0&id=c1545412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports